const c = {
  antdBackgroundElevated: 'rgb(250, 250, 250)',
  antdBackgroundElevatedBorder: 'rgb(240, 240, 240)',
  antdBreadcrumbInactive: 'rgba(0, 0, 0, 0.45)',
  appleBackground: '#EFEFF4',
  applePickerBackground: '#DEDEDE',
  appleBlue: '#006aff',
  appleInputs: '#efedf0',
  appleLines: '#CECED2',
  appleGrey: '#edecf2',
  appleRed: '#ff3b30',
  appleTooltip: '#333333',
  bermudagrey: '#78909C',
  black: '#000',
  blue: '#22A7CC',
  borderGrey: '#eeeeee',
  inactiveGrey: '#E0E0E0',
  borderLightGrey: '#f3f3f3',
  darkBlue: '#14171a',
  darkThemePrimary: '#19222d',
  darkThemePrimarySimilar: '#414b59',
  darkThemeSecondary: '#222c38',
  darkGrey: '#444444',
  darkerGrey: '#929292',
  evenDarkerGrey: '#818181',
  email: '#DD5144',
  facebook: '#3B5998',
  gray98: '#fafafa',
  grayishGreen: '#dff0d8',
  grayishGreenDarker: '#d6e9c6',
  grayishOrange: '#faebcc',
  grayishRed: '#f2dede',
  grayishRedDarker: '#ebccd1',
  grayishYellow: '#fcf8e3',
  green: '#54C08D',
  grey: '#464242',
  greyishBlack: '#4A4A4A',
  gray80: '#cccccc',
  instagram: '#bc2a8d',
  instagramText: '#393939',
  lightBlue: '#44c9ee',
  lightYellow: '#fff78a',
  darkYellow: '#b4ac61',
  lighterBlue: '#66daff',
  lightGrey: '#d5d5d5',
  lightThemePrimary: '#ffffff',
  lightThemePrimarySimilar: '#dfdfdf',
  lightThemeSecondary: '#cdcdcd',
  limeGreen: '#3c763d',
  moderateOrange: '#8a6d3b',
  moderateRed: '#a94442',
  nero: '#191919',
  niceBlue: '#20a8d8',
  niceBlueDark: '#187da0',
  niceLightBlue: '#63c2de',
  niceLightBlueDark: '#2eadd3',
  niceGreen: '#4dbd74',
  niceGreenDark: '#409e61',
  niceRed: '#f86c6b',
  niceRedDark: '#f5302e',
  niceYellow: '#ffc107',
  niceYellowDark: '#c69500',
  pink: '#FF005A',
  snapchat: '#ede904',
  translucentDark: 'rgba(0,0,0,.4)',
  translucentPink: 'rgba(255,68,134,.8)',
  translucentGrey: 'rgba(206,206,210,.8)',
  transparent: 'transparent',
  transparentWhite: 'rgba(255,255,255,0.7)',
  twitter: '#1da1f2',
  veryLightGreen: '#b3ffa5',
  veryLightGrey: '#fafafa',
  veryLightYellow: '#fff9a5',
  whatsapp: '#34A34F',
  white: '#ffffff',
  whitesmoke: '#f5f5f5',
  yellow: '#fff1c6',
}

export const colors = {
  background: c.white,
  backgroundLight: c.borderLightGrey,
  border: c.appleLines,
  greyBackground: c.gray98,
  icon: c.darkerGrey,
  inputBackground: c.borderLightGrey,
  modalBackground: c.translucentDark,
  darkerBackground: c.borderLightGrey,
  placeholder: c.darkerGrey,
  primary: c.pink,
  socialLink: c.appleLines,
  text: c.darkBlue,
  F3F3F3: c.greyishBlack,
  textLight: c.darkerGrey,
  secondary: c.appleBlue,
  separator: c.appleLines,
  softGrey: c.borderLightGrey,
  ...c,
}
